import monthsFromNow from '../../modules/monthsFromNow';
import getSVCFee from '../../modules/getSVCFee';
import getVesselFee from '../../modules/getVesselFee';
import getBaseFeeFromWeight from '../../modules/getBaseFeeFromWeight';
import getPenaltiesFromPipeAndWeight from '../../modules/getPenaltiesFromPipeAndWeight';
import getPipeValue from '../../modules/getPipeValue';
import getMonthsFromNowNumber from '../../modules/getMonthsFromNowNumber';
import { VEHICLES, PIPE, ACTIONS } from '../../modules/constants';
import todaysMonthNumber from '../../modules/todaysMonthNumber';
import processPipe from '../../modules/processPipe';
import getVehicleWeightOrLengthLimitById from '../../modules/getVehicleWeightOrLengthLimitById';
import precise from '../../modules/precise';

const SET_SELECTED_VEHICLE = 'fcr/registration/SET_SELECTED_VEHICLE';
const SET_TODAYS_DATE = 'fcr/registration/SET_TODAYS_DATE';
const SET_MONTHS_FROM_NOW = 'fcr/registration/SET_MONTHS_FROM_NOW';
const TOGGLE_SHOULD_CHARGE_BRANCH_FEE = ACTIONS.TOGGLE_SHOULD_CHARGE_BRANCH_FEE;
const TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE = ACTIONS.TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE;
const TOGGLE_LOCKED_COUNTY_FEE = 'fcr/registration/TOGGLE_LOCKED_COUNTY_FEE';
const SET_SVC_TOTAL = 'fcr/registration/SET_SVC_TOTAL';
const SET_BASE_FEE = 'fcr/registration/SET_BASE_FEE';
const SET_SHOW_MOBILE_HOME = 'fcr/registration/SET_SHOW_MOBILE_HOME';
const SET_PLATE_FEE_VALUE = 'fcr/registration/SET_PLATE_FEE_VALUE';
const SET_TRANSFER_FEE_VALUE = 'fcr/registration/SET_TRANSFER_FEE_VALUE';
const SET_TO_MOTOR_VEHICLE_SELECTION = 'fcr/registration/SET_TO_MOTOR_VEHICLE_SELECTION';
const SET_TO_MOBILE_HOME_SELECTION = 'fcr/registration/SET_TO_MOBILE_HOME_SELECTION';
const SET_TO_HEAVY_TRUCK_SELECTION = 'fcr/registration/SET_TO_HEAVY_TRUCK_SELECTION';
const SET_TO_LEASE_SELECTION = 'fcr/registration/SET_TO_LEASE_SELECTION';
const SET_TO_BUS_SELECTION = 'fcr/registration/SET_TO_BUS_SELECTION';
const SET_TO_VESSEL_SELECTION = 'fcr/registration/SET_TO_VESSEL_SELECTION';
const TOGGLE_VESSEL_COMMERCIAL_EXEMPT = 'fcr/registration/TOGGLE_VESSEL_COMMERCIAL_EXEMPT';
const SET_VEHICLE_WEIGHT = 'fcr/registration/SET_VEHICLE_WEIGHT';
const TOGGLE_APPLY_PENALTY_FEE = 'fcr/registration/TOGGLE_APPLY_PENALTY_FEE';
const TOGGLE_APPLY_SECOND_YEAR_FEE = 'fcr/registration/TOGGLE_APPLY_SECOND_YEAR_FEE';
const SET_CREDIT_CLASS = 'fcr/registration/SET_CREDIT_CLASS';
const SET_CREDIT_WEIGHT = 'fcr/registration/SET_CREDIT_WEIGHT';
const SET_CREDIT_MONTHS = 'fcr/registration/SET_CREDIT_MONTHS';
const RESET_CREDIT = 'fcr/registration/RESET_CREDIT';
const TOGGLE_APPLY_CREDIT = 'fcr/registration/TOGGLE_APPLY_CREDIT';
const SET_INITIAL_REGISTRATION_FEE = 'fcr/registration/SET_INITIAL_REGISTRATION_FEE';
const SET_PERSONALIZED_PLATE = 'fcr/registration/SET_PERSONALIZED_PLATE';
const SET_SPECIALTY_PLATE = 'fcr/registration/SET_SPECIALTY_PLATE';
const SET_PARK_PLACARD_FEE = 'fcr/registration/SET_PARK_PLACARD_FEE';
const SET_MAIL_FEE = 'fcr/registration/SET_MAIL_FEE';
const SET_MAIL_FEE_CUSTOM_FEE = 'fcr/registration/SET_MAIL_FEE_CUSTOM_FEE';
const SET_MAIL_FEE_CUSTOM_DESCRIPTION = 'fcr/registration/SET_MAIL_FEE_CUSTOM_DESCRIPTION';
const SET_REGISTRATION_CONSOLE = 'fcr/registration/SET_REGISTRATION_CONSOLE';

const INITIAL_STATE = {
  // Locked County Fees
  shouldChargeBranchFee: true,
  shouldChargeVesselCountyFees: true,
  isLocked: true,
  BFfee: 0.50, // Branch Fee. Either 0 or 0.50
  VesselCountyFee: 1, // Vessels County Fee. Either 0 or 1.00

  SVCFEE_TOTAL: 0, // The total SVCFee
  BaseFee: 0, // The Base Fee set by by Vehicle Type
  globalFees: {
    cmm: 0, // not sure if I need this here or not.
  },
  today: new Date(),
  selectedMonthNumber: todaysMonthNumber(),
  monthsFromNow: 12,
  selectedVehicleType: null,
  selectedVehicleValue: null,
  pipe: {},
  showMobileHomeRow: false,

  // Plate Fee
  plateFee: '0.00',
  plateFeeSelectedValue: '',
  plateFeeSelectedValueLabel: 'Plate Fee', // the default for print view

  // Transfer Fee
  transferFee: '0.00',
  transferFeeSelectedValue: null,
  transferFeeSelectedValueLabel: 'Transfer Fee', // the default for print view

  vesselCommercialExempt: false,
  vesselShowExemptFee: false,
  vesselCommercialFee: '50.00',
  showVehicleWeightFee: false,

  // Vehicle Weight
  vehicleWeight: 0,
  vehicleWeightFee: 0,
  vehicleWeightOrLengthLimit: null,

  // Penalty Fee (the actual fee is calculated in a selector)
  applyPenaltyFee: false,

  // Second Year Fee
  applySecondYearFee: false,
  secondYearFee: '0.00',

  // credit
  creditClass: 0,
  creditWeight: null,
  creditMonths: null,
  applyCredit: false,
  creditTotal: 0,

  // Initial Registration
  initialRegistrationFee: '0.00',
  applyInitialRegistrationFee: false,

  // Personalized Plate Fee
  personalizedPlateFee: '0.00',
  personalizedPlateFeeSelectedValue: 'none',
  personalizedPlateFeeSelectedValueLabel: 'Personalized Plate Fee', // the default for print view

  // SpecialtyPlate
  specialtyPlateTotal: '0.00',
  specialtyPlateSelectedValue: null,
  specialtyPlateName: null,
  specialtyPlateImageName: null,

  // Park Placard
  parkPlacardFee: '0.00',
  parkPlacardSelectedValue: 'None',
  parkPlacardName: 'Park Placard Fee', // the default for print view

  // Mail Fee
  mailFee: '0.00',
  mailFeeName: 'Mail Fee', // default for print view
  mailFeeSelectedValue: 'No Mail Fee|0.00',

  // Mail Fee Custom
  mailFeeShowCustomAmount: false,
  mailFeeCustomFee: '0.00',
  mailFeeCustomDescription: '',

  // Registration console
  registrationConsole: '',
};

const resetAfterVehicleSelection = {
  mobileHomeLength: 1,
  showMobileHomeRow: false,
  plateFee: '0.00',
  vesselShowExemptFee: false,
  vesselCommercialExempt: false,
  vesselCommercialFee: '50.00',
  showVehicleWeightFee: false,
  vehicleWeight: 0,
  vehicleWeightFee: 0,
  applyPenaltyFee: false,
  applySecondYearFee: false,
  secondYearFee: '0.00',
  transferFee: '0.00',
  transferFeeSelectedValue: null,
  transferFeeSelectedValueLabel: 'Transfer Fee', // default for print
  creditClass: 0,
  creditWeight: null,
  creditMonths: null,
  applyCredit: false,
  creditTotal: 0,
  specialtyPlateTotal: '0.00',
  specialtyPlateSelectedValue: null,
  specialtyPlateName: null,
  specialtyPlateImageName: null,
  mailFee: '0.00',
  mailFeeName: 'Mail Fee', // default for print view
  mailFeeSelectedValue: 'No Mail Fee|0.00',
  mailFeeShowCustomAmount: false,
  mailFeeCustomFee: '0.00',
  mailFeeCustomDescription: '',
  personalizedPlateFee: '0.00',
  personalizedPlateFeeSelectedValue: 'none',
  parkPlacardFee: '0.00',
  parkPlacardSelectedValue: 'None',
  parkPlacardName: 'Park Placard Fee', // default for print view
  initialRegistrationFee: '0.00',
  applyInitialRegistrationFee: false,
  // Added these to reset when a new month is selected
  SVCFEE_TOTAL: 0,
  BaseFee: 0,
  selectedVehicleType: null,
  selectedVehicleValue: null,
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case ACTIONS.RESET:
    case ACTIONS.RESET_REGISTRATION:
      return {
        ...INITIAL_STATE,

        // Don't reset the County Lock and Branch Fees.
        shouldChargeBranchFee: state.shouldChargeBranchFee,
        shouldChargeVesselCountyFees: state.shouldChargeVesselCountyFees,
        isLocked: state.isLocked,
        BFfee: state.BFfee,
        VesselCountyFee: state.VesselCountyFee,
      };
    case ACTIONS.RESET_ALL_EXCEPT_MONTH:
      return {
        ...INITIAL_STATE,
        selectedMonthNumber: state.selectedMonthNumber,
        monthsFromNow: state.monthsFromNow,

        // Don't reset the County Lock and Branch Fees.
        shouldChargeBranchFee: state.shouldChargeBranchFee,
        shouldChargeVesselCountyFees: state.shouldChargeVesselCountyFees,
        isLocked: state.isLocked,
        BFfee: state.BFfee,
        VesselCountyFee: state.VesselCountyFee,
      };
    case TOGGLE_SHOULD_CHARGE_BRANCH_FEE:
      return {
        ...INITIAL_STATE,
        shouldChargeBranchFee: !state.shouldChargeBranchFee,
        BFfee: !state.shouldChargeBranchFee ? 0.50 : 0,

        // Because the form resets on this selection, make sure to keep
        // the other county fee settings:
        shouldChargeVesselCountyFees: state.shouldChargeVesselCountyFees,
        isLocked: state.isLocked,
        VesselCountyFee: state.shouldChargeVesselCountyFees ? 1 : 0,
      };
    case TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE:
      return {
        ...INITIAL_STATE,
        shouldChargeVesselCountyFees: !state.shouldChargeVesselCountyFees,
        VesselCountyFee: !state.shouldChargeVesselCountyFees ? 1 : 0,

        // Because the form resets on this selection, make sure to keep
        // the other county fee settings:
        shouldChargeBranchFee: state.shouldChargeBranchFee,
        BFfee: state.shouldChargeBranchFee ? 0.50 : 0,
        isLocked: state.isLocked,
      };
    case TOGGLE_LOCKED_COUNTY_FEE:
      return {
        ...state,
        isLocked: !state.isLocked,
      };
    case SET_MONTHS_FROM_NOW:
      return {
        ...INITIAL_STATE,
        today: state.today,
        selectedMonthNumber: state.selectedMonthNumber,
        monthsFromNow: action.number,
      };
    case ACTIONS.RESET_MOBILE_HOME:
      return {
        ...state,
        showMobileHomeRow: false,
        mobileHomeLength: 1,
      };
    case SET_PARK_PLACARD_FEE:
      return {
        ...state,
        parkPlacardName: action.name,
        parkPlacardFee: action.fee,
        parkPlacardSelectedValue: action.selectedValue,
        parkPlacardSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_MAIL_FEE:
      return {
        ...state,
        mailFeeName: action.name,
        mailFee: action.fee,
        mailFeeSelectedValue: action.selectedValue,
        mailFeeShowCustomAmount: action.name === 'Custom',
        mailFeeCustomFee: action.name !== 'Custom' ? '0.00' : state.mailFeeCustomFee,
        mailFeeCustomDescription: action.name !== 'Custom' ? '' : state.mailFeeCustomDescription,
      };
    case SET_MAIL_FEE_CUSTOM_FEE:
      return {
        ...state,
        mailFeeCustomFee: action.fee,
      };
    case SET_MAIL_FEE_CUSTOM_DESCRIPTION:
      return {
        ...state,
        mailFeeCustomDescription: action.description,
      };
    case TOGGLE_APPLY_PENALTY_FEE:
      return {
        ...state,
        applyPenaltyFee: !state.applyPenaltyFee,
        penaltyFee: getPenaltiesFromPipeAndWeight(state.selectedVehicleValue, state.vehicleWeight),
      };
    case TOGGLE_VESSEL_COMMERCIAL_EXEMPT:
      return {
        ...state,
        vesselCommercialExempt: !state.vesselCommercialExempt,
        vesselCommercialFee: state.vesselCommercialExempt ? precise(50) : precise(0),
      };
    case SET_SPECIALTY_PLATE:
      return {
        ...state,
        specialtyPlateTotal: action.total,
        specialtyPlateSelectedValue: action.specialtyPlateSelectedValue,
        specialtyPlateName: action.specialtyPlateName,
        specialtyPlateImageName: action.specialtyPlateImageName,
      };
    case SET_INITIAL_REGISTRATION_FEE:
      return {
        ...state,
        initialRegistrationFee: action.fee,
        applyInitialRegistrationFee: action.applyInitialRegistrationFee,
      };
    case SET_CREDIT_CLASS:
      return {
        ...state,
        creditClass: action.classNumber,
      };
    case SET_PERSONALIZED_PLATE:
      return {
        ...state,
        personalizedPlateFee: action.fee,
        personalizedPlateFeeSelectedValue: action.selectedValue,
        personalizedPlateFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_CREDIT_WEIGHT:
      return {
        ...state,
        creditWeight: action.weight,
      };
    case SET_CREDIT_MONTHS:
      return {
        ...state,
        creditMonths: action.months,
      };
    case TOGGLE_APPLY_CREDIT:
      return {
        ...state,
        applyCredit: action.applyCredit,
        creditTotal: action.creditTotal,
      };
    case RESET_CREDIT:
      return {
        ...state,
        applyCredit: false,
        creditTotal: 0,
        creditClass: null,
        creditWeight: null,
        creditMonths: null,
        transferFee: '0.00',
        transferFeeSelectedValueLabel: 'Transfer Fee',
      };
    case TOGGLE_APPLY_SECOND_YEAR_FEE:
      return {
        ...state,
        applySecondYearFee: !state.applySecondYearFee,
        // reset the personal/special plate dropdown which depends on
        // the second year fee calculation. Later you can move
        // these to a selector so that it can update the fee without
        // needing to reset. For now, we will emulate the PDF.
        personalizedPlateFee: '0.00',
        personalizedPlateFeeSelectedValue: 'none',
        specialtyPlateTotal: '0.00',
        specialtyPlateSelectedValue: null,
        specialtyPlateName: null,
        specialtyPlateImageName: null,
      };
    case ACTIONS.SET_MOBILE_HOME_LENGTH:
      return {
        ...state,
        mobileHomeLength: action.length,
        mobileHomeFeeTotal: Number(action.length * (state.BaseFee + state.SVCFEE_TOTAL)),
      };
    case SET_SHOW_MOBILE_HOME:
      return {
        ...state,
        showMobileHomeRow: action.payload,
      };
    case SET_VEHICLE_WEIGHT:
      return {
        ...state,
        vehicleWeight: action.weight,
        vehicleWeightFee: getBaseFeeFromWeight({
          pipe: state.selectedVehicleValue,
          monthsFromNow: state.monthsFromNow,
          vehicleWeight: action.weight,
          selectedVehicleType: state.selectedVehicleType,
        }),
        penaltyFee: getPenaltiesFromPipeAndWeight(state.selectedVehicleValue, action.weight),

        // Experiment: recalculate SVC when weight is entered.
        SVCFEE_TOTAL: getSVCFee({
          numberOfMonths: state.monthsFromNow,
          weightlistValue: action.weight,
          vehicleClass: getPipeValue(state.selectedVehicleValue, PIPE.CLASS_CODE),
          BFfee: state.BFfee,
        }),
      };
    case SET_PLATE_FEE_VALUE:
      return {
        ...state,
        plateFee: action.fee,
        plateFeeSelectedValue: action.selectedValue,
        plateFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_TRANSFER_FEE_VALUE:
      return {
        ...state,
        transferFee: action.fee,
        transferFeeSelectedValue: action.selectedValue,
        transferFeeSelectedValueLabel: action.selectedValueLabel,
      };
    case SET_SVC_TOTAL:
      return {
        ...state,
        SVCFEE_TOTAL: action.total,
      };
    case SET_BASE_FEE:
      return {
        ...state,
        BaseFee: Number(action.fee),
      };
    case ACTIONS.SET_EXPIRATION_MONTH:
      return {
        ...INITIAL_STATE,
        selectedMonthNumber: Number(action.monthNumber),
        monthsFromNow: getMonthsFromNowNumber(monthsFromNow(state.today, action.monthNumber)),

        // Don't reset the County Lock and Branch Fees.
        shouldChargeBranchFee: state.shouldChargeBranchFee,
        shouldChargeVesselCountyFees: state.shouldChargeVesselCountyFees,
        isLocked: state.isLocked,
        BFfee: state.BFfee,
        VesselCountyFee: state.VesselCountyFee,
      };
    case SET_TODAYS_DATE:
      return {
        ...state,
        today: new Date(action.dateString),
      };
    case SET_TO_MOTOR_VEHICLE_SELECTION:
      return {
        ...state,
        ...resetAfterVehicleSelection,
        selectedVehicleType: VEHICLES.MOTOR_VEHICLE,
        selectedVehicleValue: action.selection,
        pipe: processPipe(action.selection),
        BaseFee: action.selection !== '0' ? Number(getPipeValue(action.selection, state.monthsFromNow || 12)) : 0,
        SVCFEE_TOTAL: getSVCFee({
          numberOfMonths: state.monthsFromNow,
          weightlistValue: null,
          vehicleClass: getPipeValue(action.selection, PIPE.CLASS_CODE),
          BFfee: state.BFfee,
        }),
        penaltyFee: getPenaltiesFromPipeAndWeight(action.selection, state.vehicleWeight),
      };
    case SET_TO_HEAVY_TRUCK_SELECTION:
      return {
        ...state,
        ...resetAfterVehicleSelection,
        selectedVehicleType: VEHICLES.HEAVY_TRUCKS,
        selectedVehicleValue: action.selection,
        pipe: processPipe(action.selection),
        BaseFee: action.selection !== '0' ? Number(getPipeValue(action.selection, state.monthsFromNow || 12)) : 0,
        SVCFEE_TOTAL: getSVCFee({
          numberOfMonths: state.monthsFromNow,
          weightlistValue: null,
          vehicleClass: getPipeValue(action.selection, PIPE.CLASS_CODE),
          BFfee: state.BFfee,
        }),
      };
    case SET_TO_LEASE_SELECTION:
      return {
        ...state,
        ...resetAfterVehicleSelection,
        selectedVehicleType: VEHICLES.LEASE_HIRE_TRAILER,
        selectedVehicleValue: action.selection,
        pipe: processPipe(action.selection),
        BaseFee: 0,
        SVCFEE_TOTAL: getSVCFee({
          numberOfMonths: state.monthsFromNow,
          weightlistValue: null,
          vehicleClass: getPipeValue(action.selection, PIPE.CLASS_CODE),
          BFfee: state.BFfee,
        }),
        showVehicleWeightFee: true,
        penaltyFee: getPenaltiesFromPipeAndWeight(action.selection, state.vehicleWeight),
        vehicleWeightOrLengthLimit: getVehicleWeightOrLengthLimitById(getPipeValue(action.selection, PIPE.DESCRIPTION)),
      };
    case SET_TO_MOBILE_HOME_SELECTION:
      return {
        ...state,
        ...resetAfterVehicleSelection,
        selectedVehicleType: VEHICLES.MOBILE_HOMES,
        selectedVehicleValue: action.selection,
        pipe: processPipe(action.selection),
        BaseFee: action.selection !== '0' ? Number(getPipeValue(action.selection, 12)) : 0,
        penaltyFee: getPenaltiesFromPipeAndWeight(action.selection, state.vehicleWeight),
        SVCFEE_TOTAL: getSVCFee({
          numberOfMonths: monthsFromNow(state.today, 12).split(' ')[0], // auto-set to DEC in the PDF
          weightlistValue: null,
          vehicleClass: getPipeValue(action.selection, PIPE.CLASS_CODE),
          BFfee: state.BFfee,
        }),
        showMobileHomeRow: [76, 78].indexOf(Number(getPipeValue(action.selection, PIPE.CLASS_CODE))) === -1 && action.selection !== '0',
        // set the number of Months to DEC (12)
        monthsFromNow: getMonthsFromNowNumber(monthsFromNow(state.today, 12)),
        selectedMonthNumber: 12,
      };
    case SET_TO_VESSEL_SELECTION:
      return {
        ...state,
        ...resetAfterVehicleSelection,
        selectedVehicleType: VEHICLES.VESSELS,
        selectedVehicleValue: action.selection,
        pipe: processPipe(action.selection),
        BaseFee: 0,
        vesselShowExemptFee: Number(getPipeValue(action.selection, 21)) === 50,
        SVCFEE_TOTAL: getVesselFee({
          shouldChargeVesselCountyFees: state.shouldChargeVesselCountyFees,
          selectedVehicleDescription: getPipeValue(action.selection, PIPE.DESCRIPTION),
          BaseFee: action.selection !== '0' ? Number(getPipeValue(action.selection, state.selectedMonthNumber || 12)) : 0,
          BFfee: state.BFfee,
          VesselCountyFee: state.VesselCountyFee,
          cmm: state.globalFees.cmm,
          pipe: processPipe(action.selection),
        }),
      };
    case SET_TO_BUS_SELECTION:
      return {
        ...state,
        ...resetAfterVehicleSelection,
        selectedVehicleType: VEHICLES.BUSES_TRAILER,
        selectedVehicleValue: action.selection,
        pipe: processPipe(action.selection),
        BaseFee: action.selection !== '0' ? getBaseFeeFromWeight({
          pipe: action.selection,
          monthsFromNow: state.monthsFromNow,
          vehicleWeight: state.vehicleWeight,
          selectedVehicleType: VEHICLES.BUSES_TRAILER,
        }) : 0,
        SVCFEE_TOTAL: getSVCFee({
          numberOfMonths: getPipeValue(action.selection, 'r1') === 's' ? 6 : state.monthsFromNow,
          weightlistValue: state.vehicleWeight,
          vehicleClass: getPipeValue(action.selection, PIPE.CLASS_CODE),
          BFfee: state.BFfee,
        }),
        showVehicleWeightFee: true,
        penaltyFee: getPenaltiesFromPipeAndWeight(action.selection, state.vehicleWeight),
        vehicleWeightOrLengthLimit: getVehicleWeightOrLengthLimitById(getPipeValue(action.selection, PIPE.DESCRIPTION)),
        // Certain bus selections (class 360) want to force a 6-month option
        // but we are going to remove this for now and see if we really need it.
        // Note that removing this 6-month force also forces us to change one line of
        // code in getSVCFees() for vehicle class 360.
        // monthsFromNow: getPipeValue(action.selection, 'r1') === 's' ? 6 : state.monthsFromNow,
      };
    case SET_REGISTRATION_CONSOLE:
      return {
        ...state,
        registrationConsole: action.text,
      };
    default:
      return state;
  }
}

export function setExpirationMonth(monthNumber) {
  return {
    type: ACTIONS.SET_EXPIRATION_MONTH,
    monthNumber,
  };
}

export function setMonthsFromNow(number) {
  return {
    type: SET_MONTHS_FROM_NOW,
    number,
  };
}

export function setTodaysDate(dateStr) {
  return {
    type: SET_TODAYS_DATE,
    dateString: new Date(dateStr),
  };
}

export function setSelectedVehicle(vehicleType, vehicleValue) {
  return {
    type: SET_SELECTED_VEHICLE,
    vehicleType,
    vehicleValue,
  };
}

export function setBaseFee(fee) {
  return {
    type: SET_BASE_FEE,
    fee,
  };
}

export function toggleShouldChargeBranchFee() {
  return {
    type: TOGGLE_SHOULD_CHARGE_BRANCH_FEE,
  };
}

export function toggleShouldChargeVesselCountyFee() {
  return {
    type: TOGGLE_SHOULD_CHARGE_VESSEL_COUNTY_FEE,
  };
}

export function toggleLockedCountyFee() {
  return {
    type: TOGGLE_LOCKED_COUNTY_FEE,
  };
}

export function toggleVesselCommercialExempt() {
  return {
    type: TOGGLE_VESSEL_COMMERCIAL_EXEMPT,
  };
}

export function setSVCTotal(total) {
  return {
    type: SET_SVC_TOTAL,
    total,
  };
}

export function setShowMobileHome(bool) {
  return {
    type: SET_SHOW_MOBILE_HOME,
    payload: bool,
  };
}

export function setPlateFeeValue(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_PLATE_FEE_VALUE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function setTransferFeeValue(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_TRANSFER_FEE_VALUE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function setToMotorVehicleSelection(selection) {
  return {
    type: SET_TO_MOTOR_VEHICLE_SELECTION,
    selection,
  };
}

export function setToMobileHomeSelection(selection) {
  return {
    type: SET_TO_MOBILE_HOME_SELECTION,
    selection,
  };
}

export function setToVesselSelection(selection) {
  return {
    type: SET_TO_VESSEL_SELECTION,
    selection,
  };
}

export function setToBusSelection(selection) {
  return {
    type: SET_TO_BUS_SELECTION,
    selection,
  };
}

export function setToHeavyTruckSelection(selection) {
  return {
    type: SET_TO_HEAVY_TRUCK_SELECTION,
    selection,
  };
}

export function setToLeaseSelection(selection) {
  return {
    type: SET_TO_LEASE_SELECTION,
    selection,
  };
}

export function setVehicleWeight(weight) {
  return {
    type: SET_VEHICLE_WEIGHT,
    weight,
  };
}

export function toggleApplyPenaltyFee() {
  return {
    type: TOGGLE_APPLY_PENALTY_FEE,
  };
}

export function toggleApplySecondYearFee() {
  return {
    type: TOGGLE_APPLY_SECOND_YEAR_FEE,
  };
}

export function setCreditClass(classNumber) {
  return {
    type: SET_CREDIT_CLASS,
    classNumber,
  };
}

export function setCreditWeight(weight) {
  return {
    type: SET_CREDIT_WEIGHT,
    weight,
  };
}

export function setCreditMonths(months) {
  return {
    type: SET_CREDIT_MONTHS,
    months,
  };
}

export function toggleApplyCredit(applyCredit, creditTotal) {
  return {
    type: TOGGLE_APPLY_CREDIT,
    applyCredit,
    creditTotal,
  };
}

export function setInitialRegistationFee(fee, applyInitialRegistrationFee) {
  return {
    type: SET_INITIAL_REGISTRATION_FEE,
    fee,
    applyInitialRegistrationFee,
  };
}

export function setPersonalizedPlate(fee, selectedValue, selectedValueLabel) {
  return {
    type: SET_PERSONALIZED_PLATE,
    fee,
    selectedValue,
    selectedValueLabel,
  };
}

export function setSpecialtyPlate(object) {
  const {
    total,
    specialtyPlateSelectedValue,
    specialtyPlateName,
    specialtyPlateImageName,
  } = object;
  return {
    type: SET_SPECIALTY_PLATE,
    total,
    specialtyPlateSelectedValue,
    specialtyPlateName,
    specialtyPlateImageName,
  };
}

export function setParkPlacardFee(name, fee, selectedValue) {
  return {
    type: SET_PARK_PLACARD_FEE,
    name,
    fee,
    selectedValue,
  };
}

export function setMailFee(name, fee, selectedValue) {
  return {
    type: SET_MAIL_FEE,
    name,
    fee,
    selectedValue,
  };
}

export function setMailFeeCustomFee(fee) {
  return {
    type: SET_MAIL_FEE_CUSTOM_FEE,
    fee,
  };
}

export function setMailFeeCustomDescription(description) {
  return {
    type: SET_MAIL_FEE_CUSTOM_DESCRIPTION,
    description,
  };
}

export function resetAll() {
  return {
    type: ACTIONS.RESET,
  };
}

export function resetAllExceptMonth() {
  return {
    type: ACTIONS.RESET_ALL_EXCEPT_MONTH,
  };
}

export function resetRegistration() {
  return {
    type: ACTIONS.RESET_REGISTRATION,
  };
}

export function resetCredit() {
  return {
    type: RESET_CREDIT,
  };
}

export function setRegistrationConsole(text) {
  return {
    type: SET_REGISTRATION_CONSOLE,
    text,
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/registration.js